import type { SVGProps } from 'react'

interface SquareFootIconProps extends SVGProps<SVGSVGElement> {}

export function SquareFootIcon(props: SquareFootIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M232.62-150.77q-34.31 0-58.08-23.77-23.77-23.77-23.77-58.08v-474.91q0-25.54 22.96-35.5 22.96-9.97 40.27 7.34l74.62 74.62-42.46 42.46 23.38 23.38L312-637.69l94.77 94.77-42.46 42.46 23.38 23.38 42.46-42.46 96.31 96.31L484-380.77l23.38 23.38 42.46-42.46 94.77 94.77-42.46 42.46 23.39 23.39L668-281.69l68.46 68.46q16.92 16.92 6.96 39.69-9.96 22.77-35.12 22.77H232.62zM252.31-240H572L240-572v319.69q0 5.39 3.46 8.85t8.85 3.46z" />
    </svg>
  )
}
